<span class="indicator" [class]="StyleClass" [pTooltip]="name" tooltipPosition="bottom" tooltipStyleClass="u-tooltip">
  <span [style.width]="size" [style.height]="size" class="indicator-dot" [style.background]="color ? 'var(--' + color + ')' : ''"></span>
  <div class="indicator-dot-wrapper" [pTooltip]="name" tooltipPosition="bottom" tooltipStyleClass="u-tooltip"></div>
</span>
